import { useUnderwritingStore } from '../../store/underwritingStore'
import { formatCurrency } from '../../utils/currencyUtils'

export default function ScenarioBar() {
  const { activeScenario, setActiveScenario, getAllResults } = useUnderwritingStore()
  const all = getAllResults()

  const scenarios = [
    { key: 'worst', label: '📉 Worst Case', color: '#1e3a8a', bg: '#dbeafe', border: '#60a5fa' },
    { key: 'base',  label: '📊 Base Case',  color: '#1d4ed8', bg: '#dbeafe', border: '#93c5fd' },
    { key: 'best',  label: '📈 Best Case',  color: '#1d4ed8', bg: '#dbeafe', border: '#60a5fa' },
  ]

  return (
    <div className="uw-scenario-bar">
      <span className="uw-scenario-label">Scenario:</span>
      <div className="uw-scenario-btns">
        {scenarios.map(s => (
          <button
            key={s.key}
            className={`uw-scenario-btn ${activeScenario === s.key ? 'uw-scenario-btn--active' : ''}`}
            style={activeScenario === s.key ? {
              background: s.bg,
              borderColor: s.border,
              color: s.color,
            } : {}}
            onClick={() => setActiveScenario(s.key)}
          >
            {s.label}
            <span className="uw-scenario-noi">
              NOI {formatCurrency(all[s.key].noi)}
            </span>
          </button>
        ))}
      </div>
      <div className="uw-scenario-compare">
        <span className="uw-scenario-compare-item uw-compare--best">
          Best IRR: {(all.best.irr * 100).toFixed(1)}%
        </span>
        <span className="uw-scenario-compare-item uw-compare--base">
          Base IRR: {(all.base.irr * 100).toFixed(1)}%
        </span>
        <span className="uw-scenario-compare-item uw-compare--worst">
          Worst IRR: {(all.worst.irr * 100).toFixed(1)}%
        </span>
      </div>
    </div>
  )
}
